import { Icon, Popover, PopoverGroup, HelpFilledIcon, Paragraph } from '@norges-domstoler/dds-components';
import IContentDeliveryApi from '@episerver/spa-core/dist/ContentDelivery/IContentDeliveryAPI';
import WordsPageData from '../Models/Content/WordsPageData';
import { createRoot } from 'react-dom/client';

export function PopOver(api: IContentDeliveryApi, callFromBlock: boolean = false) {
    const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    const idList: Array<string> = [];
    const className = 'popover';

    // all tooltip words have a className class
    const popovers = document.getElementsByClassName(className);
    if (popovers !== null && popovers.length > 0) {
        for (let i = 0; i < popovers.length; i++) {
            if (guidRegex.test(popovers[i].id)) {
                idList.push(popovers[i].id);
            }
        }
    }

    idList.forEach((id, index) => {
        try {
            if (guidRegex.test(id)) {
                api.getContent<WordsPageData>(id).then((word) => {
                    setPopOver(word as WordsPageData, id, index, callFromBlock);
                });
            }
        } catch (error) {
            console.log('Error creating popover component for id: ', id, ' error message: ', error);
        }
    });
}

function setPopOver(word: WordsPageData, id: string, index: number, callFromBlock: boolean) {
    const popOverEl = document.getElementById(id);
    if (word && popOverEl) {
        const header = word.name.toString();
        const popOverComponenet = (
            <PopoverGroup popoverId={header + '_' + index.toString()}>
                <button className="pop-button focus-internal-link">
                    {!callFromBlock ? popOverEl.innerText : popOverEl.innerHTML}
                    <Icon iconSize="small" icon={HelpFilledIcon}></Icon>
                </button>
                <Popover header={header} placement={'bottom'} withCloseButton={true} className="popover-typography">
                    <Paragraph style={{ maxWidth: '500px' }}>
                        <span
                            className="xhtml-container-link-styling"
                            dangerouslySetInnerHTML={{ __html: word.wordDescription.value }}
                        />
                    </Paragraph>
                </Popover>
            </PopoverGroup>
        );
        popOverEl.classList.remove('popover');
        popOverEl.removeAttribute('id');
        popOverEl.removeAttribute('class');
        const root = createRoot(popOverEl);
        root.render(popOverComponenet);
    }
}
